import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { Icon } from '@/lib/icons';
import type { LeaderboardCopy } from '../leaderboard-copy';

export function LeaderboardError({ copy, retryLabel, onRetry }: { copy: LeaderboardCopy; retryLabel: string; onRetry: () => void }) {
  return (
    <div className="rounded-lg border border-border/60 bg-surface">
      <EmptyState
        icon="alertTriangle"
        title={copy.errorTitle}
        description={copy.errorHint}
        action={
          <Button variant="outline" size="sm" onClick={onRetry}>
            <Icon name="refreshCw" />
            {retryLabel}
          </Button>
        }
      />
    </div>
  );
}
